// AvailabilityList.jsx


import React from "react";
import { Box, Typography, Button } from "@mui/material";
import moment from "moment";

const AvailabilityList = ({
  specificAvailability,
  onRemoveSpecific,
}) => (
  <Box sx={{ mt: 3 }}>
    <Typography variant="h6">Specific Dates:</Typography>
    {specificAvailability.length === 0 && (
      <Typography variant="body2">— none —</Typography>
    )}
    {specificAvailability.map((a, idx) => (
      <Box
        key={a.id}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography>
          {moment(a.date).format("LL")} &nbsp;
          {moment(a.startTime).format("HH:mm")} –{" "}
          {moment(a.endTime).format("HH:mm")}
          {a.isMaintenance && "  (Maintenance)"}
        </Typography>
        <Button color="error" onClick={() => onRemoveSpecific(idx)}>
          Remove
        </Button>
      </Box>
    ))}
  </Box>
);

export default AvailabilityList;



// import React from "react";
// import { Box, Typography, Button } from "@mui/material";
// import moment from "moment";

// const AvailabilityList = ({
//   specificAvailability,
//   onRemoveSpecific,
// }) => (
//   <Box sx={{ mt: 3 }}>
//     <Typography variant="h6">Specific Dates:</Typography>
//     {specificAvailability.length === 0 && (
//       <Typography variant="body2">— none —</Typography>
//     )}
//     {specificAvailability.map((a, idx) => (
//       <Box
//         key={a.id}
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 1,
//         }}
//       >
//         <Typography>
//           {moment(a.date).format("LL")} &nbsp;
//           {moment(a.startTime).format("HH:mm")} –{" "}
//           {moment(a.endTime).format("HH:mm")}
//           {a.isMaintenance && "  (Maintenance)"}
//         </Typography>
//         <Button color="error" onClick={() => onRemoveSpecific(idx)}>
//           Remove
//         </Button>
//       </Box>
//     ))}
//   </Box>
// );

// export default AvailabilityList;
